import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/$workspace/$project/settings/")({
  beforeLoad: ({ params, search }) => {
    throw redirect({ to: "/$workspace/$project/settings/variables", params, search, replace: true });
  },
});
